import { createStyles, Grid, Paper, makeStyles } from "@material-ui/core";
import * as React from "react";
import AvatarHeader from "../common/AvatarHeader";

type HomeSectionProps = {
  title: React.ReactNode;
  icon: React.ReactNode;
  onEditClick?: () => void;
};

const HomeSection: React.FunctionComponent<HomeSectionProps> = ({ title, icon, children }) => {
  const classes = useStyles({});

  return (
    <Paper square={true} className={classes.homeSection}>
      <AvatarHeader title={title} icon={icon} />
      <Grid container={true} className={classes.content}>
        {children}
      </Grid>
    </Paper>
  );
};

const useStyles = makeStyles((theme) =>
  createStyles({
    content: {
      marginTop: theme.spacing(2),
    },
    homeSection: {
      position: "relative",
      backgroundColor: "transparent",
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(2),
      padding: theme.spacing(3),
    },
    editButton: {
      position: "absolute",
      right: theme.spacing(3),
    },
  })
);

export default HomeSection;
